import { clsx } from 'clsx';
import { IJxtCollapsibleFilter } from './types';
import { useEffect, useState } from 'react';

const JxtCollapsibleFilter = ({
  label,
  defaultFolded = true,
  disabled = false,
  value,
  children,
  hasError = false,
  onFoldChange,
}: IJxtCollapsibleFilter) => {
  const [isFolded, setIsFolded] = useState<boolean>(defaultFolded);
  const effectivelyFolded = disabled ? true : isFolded;
  const classes = clsx('flex flex-col', disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer');

  useEffect(() => {
    if (onFoldChange) {
      onFoldChange(effectivelyFolded);
    }
    // adding onFoldChange here will result in infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectivelyFolded]);

  return (
    <div className="flex flex-col gap-3">
      <div className={classes} onClick={() => !disabled && setIsFolded(!isFolded)}>
        <div className="flex gap-2 items-center justify-between">
          <span className="text-body-s font-medium text-neutral-140">{label}</span>
          <i
            className={clsx(
              'fas text-neutral-120 px-2.5 py-1.5 justify-between',
              effectivelyFolded ? 'fa-chevron-right' : 'fa-chevron-down'
            )}
          />
        </div>
        {effectivelyFolded && (
          <span className={clsx('text-body-s font-medium', hasError ? 'text-red-80' : 'text-neutral-80')}>{value}</span>
        )}
      </div>
      {!effectivelyFolded && children}
    </div>
  );
};

export default JxtCollapsibleFilter;
